import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";
import "../TablesBasePage/TablesBasePage.scss";

const traggliederHeaderDefinitions = {
  header: [
    {
      columns: [
        {
          title: "",
          path: "name",
          disabled: true,
          filtered: false,
          type: "string",
        },
        {
          title: "max_charakteristische_tragfaehigkeit",
          path: "max_charakteristische_tragfaehigkeit",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.max_charakteristische_tragfaehigkeit",
          translationNamespace: "tables",
        },
        {
          title: "zugpfahl",
          path: "interpolation.zugpfahl",
          type: "string",
          disabled: false,
          filtered: false,
          infotext: "tables.notempty",
          translationKey: "tables.tragglieder.zugpfahl",
          translationNamespace: "tables",
        },
        {
          title: "druckpfahl",
          path: "interpolation.druckpfahl",
          type: "string",
          disabled: false,
          filtered: false,
          infotext: "tables.notempty",
          translationKey: "tables.tragglieder.druckpfahl",
          translationNamespace: "tables",
        },
        {
          title: "querschnitt",
          path: "querschnitt",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.querschnitt",
          translationNamespace: "tables",
        },
        {
          title: "durchmesser",
          path: "durchmesser",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.durchmesser",
          translationNamespace: "tables",
        },
        {
          title: "innendurchmesser",
          path: "knicken.innendurchmesser",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.innendurchmesser",
          translationNamespace: "tables",
        },
        {
          title: "dehnsteifigkeit",
          path: "knicken.dehnsteifigkeit",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.dehnsteifigkeit",
          translationNamespace: "tables",
        },
        {
          title: "biegesteifigkeit",
          path: "knicken.biegesteifigkeit",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.biegesteifigkeit",
          translationNamespace: "tables",
        },
        {
          title: "beiwert_eta2",
          path: "beiwert_eta2",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.beiwert_eta2",
          translationNamespace: "tables",
        },
      ],
    },
    {
      columns: [
        {
          title: "",
          path: "name",
          disabled: true,
          filtered: false,
          type: "string",
          translationKey: "tables.tragglieder.name",
          translationNamespace: "tables",
        },

        {
          title: "max_charakteristische_tragfaehigkeit_f",
          path: "max_charakteristische_tragfaehigkeit",
          type: "number",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.max_charakteristische_tragfaehigkeit_f",
          translationNamespace: "tables",
        },
        {
          title: "zugpfahl_f",
          path: "interpolation.zugpfahl",
          type: "string",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.zugpfahl_f",
          translationNamespace: "tables",
        },
        {
          title: "druckpfahl_f",
          path: "interpolation.druckpfahl",
          type: "string",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.druckpfahl_f",
          translationNamespace: "tables",
        },
        {
          title: "querschnitt_f",
          path: "querschnitt",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.querschnitt_f",
          translationNamespace: "tables",
        },

        {
          title: "durchmesser_ff",
          path: "durchmesser",
          disabled: false,
          filtered: false,
          type: "string",
          translationKey: "tables.tragglieder.durchmesser_ff",
          translationNamespace: "tables",
        },
        {
          title: "innendurchmesser_f",
          path: "knicken.innendurchmesser",
          type: "string",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.innendurchmesser_f",
          translationNamespace: "tables",
        },
        {
          title: "dehnsteifigkeit_f",
          path: "knicken.dehnsteifigkeit",
          type: "string",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.dehnsteifigkeit_f",
          translationNamespace: "tables",
        },
        {
          title: "biegesteifigkeit_f",
          path: "knicken.biegesteifigkeit",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.biegesteifigkeit_f",
          translationNamespace: "tables",
        },
        {
          title: "beiwert_eta2_f",
          path: "beiwert_eta2",
          disabled: false,
          filtered: false,
          type: "string",
          translationKey: "tables.tragglieder.beiwert_eta2_f",
          translationNamespace: "tables",
        },
      ],
    },
    {
      columns: [
        {
          title: "",
          disabled: true,
          filtered: false,
          type: "string",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.kN",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.kN",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.kN",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm2",
          translationNamespace: "tables",
        },

        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.kN",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.kNmm2",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.none",
          translationNamespace: "tables",
        },
      ],
    },
  ],
};

export default function Tragglieder({ functions: traggliederFunctions }) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;
  const { isLoading, data: elements } = traggliederFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <p>loading ...</p>;
  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader
                headerDefs={traggliederHeaderDefinitions}
                translationPrefix={"tables.tragglieder"}
              />
              <TableBody
                columns={traggliederHeaderDefinitions.header[0].columns}
                currentTableData={currentTableData}
                functions={traggliederFunctions}
              />
            </>
          )}
        </table>
      </div>

      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
